import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';

import {defaultUnitFieldValues} from 'app/businessRules';
import setFormData from 'app/lib/setFormData';
import resetForm from 'app/lib/resetForm';
import Table from 'routes/app/components/Table';
import Button from 'routes/app/components/Button';
import Icon from 'routes/app/components/Icon';
import Modal from 'routes/app/components/Modal';
import GoodsDetailModal from './GoodsDetailModal';


const GoodsTable = ({goods, goodForm, activeGood, addGood, removeGood, saveGood, packUnity, hazardous, translate}) => {

    const openForm = () => goodForm.open.onChange(true);
    const closeForm = () => goodForm.open.onChange(false);

    return (
        <ul className="collection with-header">
            <li className="collection-header">
                <h2><FormattedMessage id="unit.heading.goodsOverview"/></h2>

                {/*<Button floating onClick={addGood}><Icon>add</Icon></Button>*/}
                <GoodsDetailModal
                    packUnity={packUnity}
                    showHazardous={hazardous}
                    translate={translate}
                    fields={goodForm}
                    onClickAgree={saveGood}
                    onClickDisagree={closeForm}
                >
                    <Button floating onClick={()=>{resetForm(goodForm, defaultUnitFieldValues.good);openForm();}}><Icon>add</Icon></Button>
                </GoodsDetailModal>
            </li>
            <li>
                <Table className="with-actions" striped responsive-table>
                    <thead>
                    <tr>
                        <th data-field="desc"><FormattedMessage id="good.label.description" /></th>
                        <th data-field="weight"><FormattedMessage id="good.label.netWeight" /></th>
                        <th data-field="hzd"><FormattedMessage id="good.label.hazardous" /></th>
                        <th data-field="id"><FormattedMessage id="good.label.id" /></th>
                    </tr>
                    </thead>
                    <tbody>
                    {goods.length === 0 &&
                    <tr>
                        <td colSpan="4"><FormattedMessage id="unit.goods.noGoods"/></td>
                    </tr>
                    }
                    {goods.length > 0 && goods.map((good, index) =>
                        /*index < goods.length - 1 &&*/
                        <tr key={index}>
                            <td>{good.desc}</td>
                            <td>{good.nettoWeight}</td>
                            <td>{good.hzd ? <FormattedMessage id="label_yes"/> : <FormattedMessage id="label_no"/>}</td>
                            <td>{good.id}</td>

                            <td className="table-actions" style={{width: 90}}>
                                <GoodsDetailModal
                                    packUnity={packUnity}
                                    showHazardous={hazardous}
                                    translate={translate}
                                    fields={goodForm}
                                    onClickAgree={() => {
                                            if (good.hzdData && good.hzdData.hzdId) {
                                                goodForm.hzdData.hzdId.onChange(good.hzdData.hzdId); // make sure the form has the latest hzdId
                                            }
                                            setTimeout(()=>saveGood(),0); //Workaround: make sure onChange happens before handling the save
                                        }
                                    }
                                    onClickDisagree={closeForm}
                                >
                                    <Button className="table-actions__edit"
                                            onClick={()=>{setFormData(goodForm,good,defaultUnitFieldValues.good);openForm();}}><i
                                        className="material-icons">mode_edit</i></Button>
                                </GoodsDetailModal>

                                <Modal
                                    header={translate({id:'unit.goods.remove.confirm.title'})}
                                    onClickAgree={()=>{removeGood(good.id);}}
                                    textDisagree={translate({id:'unit.goods.remove.confirm.btnCancel'})}
                                    textAgree={translate({id:'unit.goods.remove.confirm.btnOK'})}
                                    trigger={
                                            <Button className="table-actions__remove">
                                                <i className="material-icons">delete</i>
                                            </Button>
                                        }>
                                    <p>{translate({id: 'unit.goods.remove.confirm'})}</p>
                                </Modal>

                            </td>
                        </tr>
                    )}
                    </tbody>
                </Table>
            </li>
        </ul>
    );

};

GoodsTable.propTypes = {
    goods: PropTypes.array,
    goodForm: PropTypes.object,
    activeGood: PropTypes.object,
    addGood: PropTypes.func,
    removeGood: PropTypes.func,
    packUnity: PropTypes.array,
    hazardous: PropTypes.bool,
    translate: PropTypes.func,
    saveGood: PropTypes.func
};

export default GoodsTable;